// extracted by mini-css-extract-plugin
module.exports = {"launchGRDAbout":"style_launchGRDAbout__fym_G","aboutGRDContent":"style_aboutGRDContent__2Y_Ty","aboutGRDContent__data":"style_aboutGRDContent__data__g_FQg"};